export default __webpack_public_path__ + "static/media/mouth.501923f7.svg";